import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../store';

export function useAnyModalOpen(): boolean {
  const publishModal = useSelector((state:RootState) => state.modal.publishModal)
  const activeModal = useSelector((state: RootState) => state.modal.activeModal) 
  const templateModal = useSelector((state: RootState) => state.modal.templateModal)
  const [anyModalOpen, setAnyModalOpen] = useState(false);

  useEffect(() => {
    const updateModalState = () => {
      const openedModals = document.querySelectorAll('.modal.show');
      setAnyModalOpen(openedModals?.length > 0 || templateModal || publishModal.isActive || activeModal !== null);
    };

    updateModalState();

    const observer = new MutationObserver(() => {
      updateModalState();
    });

    observer.observe(document.body, {
      attributes: true,
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, [publishModal.isActive, activeModal, templateModal]);

  return anyModalOpen;
}
